import { useMutation } from 'react-query';

import { postV2ApiCompanyIdInternationalTransfersRecipients } from 'src/client/spendesk-api';

export const useCreateRecipientsMutation = () =>
  useMutation(postV2ApiCompanyIdInternationalTransfersRecipients);
